module.exports = __webpack_public_path__ + "static/media/banner-teste-pratico-ead.af3d9d07.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner-teste-pratico-ead.png
// module id = 388
// module chunks = 0